import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutoLoginLoaderService } from 'src/app/providers/auto-login-loader.service';

@Component({
  selector: 'sm-auto-login-loader',
  templateUrl: './auto-login-loader.component.html',
  styleUrls: ['./auto-login-loader.component.scss']
})
export class AutoLoginLoaderComponent implements OnDestroy {
  loaderVisible: boolean = false;
  private _apiSubscription: Subscription;

  constructor(private loader: AutoLoginLoaderService) {
    this._apiSubscription = this.loader.showLoader.subscribe((data: boolean) =>{
      // console.log(data);

      // setTimeout(() => {
      //   this.loaderVisible = data;
      // }, 100);
           this.loaderVisible = data;
    });
   }


  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

}
